/**
 * Creates the server-side Bunyan logger wrapper and exports it
 */
const bunyan = require('bunyan');
if (Error.captureStackTrace === undefined) {
	// https://nodejs.org/api/errors.html#errors_error_capturestacktrace_targetobject_constructoropt
	Error.captureStackTrace = require('./utils/captureStackTraceShim');
}

let name = 'client-logger';
// Attempt to grab the parent application's name by window object
if (window.logOpts.name) {
	name = window.logOpts.name;
} else {
	console.error('Could not find application name in window.logOpts.name. Defaulting to "client-logger".');
}

// Create the actual Bunyan logger
const logger = bunyan.createLogger({
	name: name,
	level: window.logOpts.LOG_LEVEL || 'info',
	src: true
});

// Here we tailor the exact fields we want output from our logger
logger._emit = (rec, noemit) => {
	// Transform "msg" to "message"
	rec['message'] = rec.msg;
	delete rec.msg;

	// Transform "time" to "timestamp"
	rec['timestamp'] = rec.time;
	delete rec.time;

	// Remove other, unnecessary properties
	delete rec.hostname;
	delete rec.v;
	delete rec.pid;

	// Now forward the log on as normal
	bunyan.prototype._emit.call(logger, rec, noemit);
};

module.exports = logger;
